import React from "react";
import { Button } from "@mui/material";
import {
  Download as DownloadIcon,
  Print as PrintIcon,
  Send as SendIcon,
} from "@mui/icons-material";

const ActionButtons = ({
  handleDownloadPDF,
  handlePrintPDF,
  handleSendInvoice,
  handleSaveInvoice,
  handleSaveAsDraft,
  editableInvoice,
  isDisabled,
  documentType,
}) => {
  return (
    <div className="d-flex flex-wrap gap-2 mt-3">
      <Button
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        onClick={handleDownloadPDF}
      >
        Download PDF
      </Button>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<PrintIcon />}
        onClick={handlePrintPDF}
      >
        Print {documentType}
      </Button>
      {editableInvoice && editableInvoice.status === "Issued" ? (
        <Button
          variant="contained"
          color="primary"
          startIcon={<SendIcon />}
          onClick={handleSendInvoice}
        >
          Resend {documentType === "Estimate" ? "Estimate" : "Invoice"}
        </Button>
      ) : (
        <Button
          variant="contained"
          color="success"
          startIcon={<SendIcon />}
          onClick={handleSendInvoice}
          disabled={
            (editableInvoice && editableInvoice.status === "Issued") || isDisabled
          }
        >
          Send {documentType === "Estimate" ? "Estimate" : "Invoice"}
        </Button>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSaveAsDraft}
        disabled={isDisabled}
      >
        Save as Draft
      </Button>
      <Button
        variant="contained"
        color="success"
        onClick={handleSaveInvoice}
        disabled={isDisabled}
      >
        Save as Issued
      </Button>
    </div>
  );
};

export default ActionButtons;